var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCloudBlueNew = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.000976562,
  width: 40,
  height: 40,
  rx: 8,
  fill: "#0077FF"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.6706 11.8108C15.4074 11.8108 12.762 14.4562 12.762 17.7195C12.762 18.0005 12.7815 18.2761 12.819 18.5451L13.0673 20.3257L11.2699 20.3633C9.14795 20.4078 7.44087 22.1426 7.44087 24.2757C7.44087 26.4369 9.1929 28.189 11.3541 28.189C16.3918 28.189 21.7579 28.1892 27.3174 28.1892C30.2133 28.1892 32.5609 25.8416 32.5609 22.9457C32.5609 20.0497 30.2133 17.7021 27.3174 17.7021C26.9777 17.7021 26.647 17.7342 26.3277 17.7951L24.7751 18.0911L24.4622 16.5418C23.9171 13.8426 21.5294 11.8108 18.6706 11.8108ZM27.4482 31.3839V31.385H11.1511V31.3819C7.3188 31.2744 4.24512 28.134 4.24512 24.2757C4.24512 20.9649 6.50809 18.183 9.57199 17.392C9.74439 12.5154 13.752 8.61505 18.6706 8.61505C22.5692 8.61505 25.893 11.0642 27.1917 14.5073C27.2335 14.5067 27.2754 14.5064 27.3174 14.5064C31.9783 14.5064 35.7566 18.2848 35.7566 22.9457C35.7566 27.5628 32.0488 31.314 27.4482 31.3839Z",
  fill: "white"
})));
export { SvgCloudBlueNew as ReactComponent };